<!--
  画面名：-
  概要： システム設定、管理機能用の親コンポーネント
  備考： システム設定、管理機能用の共通SCSSを設定する
-->

<!-- HTML -->
<template lang="html">
  <!-- システム設定、管理機能のページ -->
  <!-- Vuetifyのv-appで背景を設定 -->
  <v-app class="msWrapper">
    <router-view />
  </v-app>
</template>
<!-- /HTML -->

<script>
export default { filterMain }
// keysには除外したい項目を格納する
function filterMain (datas, search, keys) {
  let searchText = []
  // keysが設定されていない場合の処理
  if (keys === undefined) {
    keys = []
  }
  // 全角スペースを半角スペースに変換後に半角スペースで検索文字を分割
  let splitText = search.replace(/　/g, ' ').split(' ')
  for (let text of splitText) {
    searchText.push(text)
  }
  // 返却用テーブル作成
  let returnTable = []

  // 検索文字複数の場合
  if (searchText.length > 1) {
    // マッチしてるかの判定を格納
    let isMatch = false
    // オブジェクトをコピー
    returnTable = Object.assign([], datas)

    // 検索文字の数だけ回す
    for (let text of searchText) {
      // 文字がnull判定
      if (text !== null && text !== '') {
        // 配列
        for (let i = 0; i < returnTable.length; i++) {
          isMatch = false
          for (let key in returnTable[i]) {
            if (returnTable[i][key] !== null && returnTable[i][key] !== '' && keys.indexOf(key) === -1) {
              if (String(returnTable[i][key]).indexOf(text.trim()) !== -1) {
                isMatch = true
                break
              }
            }
          }
          if (!isMatch) {
            returnTable.splice(i, 1)
            i--
          }
        }
      }
    }
    return returnTable
  } else {
    if (search !== '') {
      for (let list of datas) {
        for (let key in list) {
          if (list[key] !== null && list[key] !== '' && keys.indexOf(key) === -1) {
            if (String(list[key]).indexOf(search) !== -1) {
              returnTable.push(list)
              break
            }
          }
        }
      }
    } else {
      returnTable = datas
    }
    return returnTable
  }
}

</script>

<!-- プロジェクト全体の共通SCSS -->
<style lang="scss" src="@/assets/scss/global.scss"></style>
